import React from 'react';
export interface BadgeProps {
  children: React.ReactNode;
  variant?: 'blue' | 'yellow' | 'purple' | 'orange' | 'green' | 'gray';
  className?: string;
}
export function Badge({
  children,
  variant = 'gray',
  className = ''
}: BadgeProps) {
  const variantStyles = {
    blue: 'bg-blue-50 text-blue-700 border border-blue-200',
    yellow: 'bg-amber-50 text-amber-700 border border-amber-200',
    purple: 'bg-purple-50 text-purple-700 border border-purple-200',
    orange: 'bg-orange-50 text-orange-700 border border-orange-200',
    green: 'bg-emerald-50 text-emerald-700 border border-emerald-200',
    gray: 'bg-slate-50 text-slate-700 border border-slate-200'
  };
  return <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${variantStyles[variant]} ${className}`} data-id="element-329">
      {children}
    </span>;
}